// extracted by mini-css-extract-plugin
export var csatScore = "_lu-5";
export var header = "_lu-1";
export var panelWrapper = "_lu-2";
export var postPreview = "_lu-3";
export var rightContent = "_lu-0";
export var wrappingText = "_lu-4";